import SectionJustLaunched from "../JustLaunched/JustLaunched"

export default SectionJustLaunched
